import Vue from 'vue';
import Vuex from 'vuex';
import Base from '@/plugins/Base'

// Modules
import auth from '@/modules/auth/store/index'
import dashboard from '@/modules/dashboard/store/index'
import epayment from '@/modules/epayment/store/index'
import onlineRegistration from '@/modules/onlineRegistration/store/index'
import students from '@/modules/students/store/index'
import undergraduateTransfer from '@/modules/undergraduateTransfer/store/index'
import users from '@/modules/users/store/index'
import unihall from '@/modules/unihall/store/index'
import i18n from '@/plugins/i18n'
import graduateApplication from '@/modules/graduateApplication/store/index'
import courseRegistration from '@/modules/courseRegistration/store/index'
import courseTransfers from '@/modules/courseTransfers/store/index'
import conservatoryApplication from '@/modules/conservatoryApplication/store/index'
import fashionDesignApplication from '@/modules/fashionDesignApplication/store/index'
import exchangeStudentApplication from '@/modules/exchangeStudentApplication/store/index'
import turkmerApplication from '@/modules/turkmerApplication/store/index'
import ticketSystem from "@/modules/ticketSystem/store/index"
import cartoonAnimationApplication from "@/modules/cartoonAnimationApplication/store/index"
import TolesApplicationStore from "@/modules/tolesApplication/store/index"
import qs from "qs";
import ParameterService from "@/services/ParameterService";
import PromontionApplication from "@/modules/promontialApplicationForm/store/Index"
Vue.use(Vuex);
export default new Vuex.Store({
    modules: {
        auth: auth,
        dashboard: dashboard,
        epayment: epayment,
        onlineRegistration: onlineRegistration,
        students: students,
        undergraduateTransfer: undergraduateTransfer,
        turkmerApplication: turkmerApplication,
        user: users,
        unihall: unihall,
        graduateApplication: graduateApplication,
        courseRegistration: courseRegistration,
        courseTransfers,
        conservatoryApplication,
        fashionDesignApplication,
        exchangeStudentApplication,
        ticketSystem,
        cartoonAnimationApplication,
        TolesApplicationStore,
        PromontionApplication,
    },
    state: () => ({
        authLayout: {},
        appLayout: {
            sideBarExpandedWrapper: false
        },
        nightMode: false,
        locale: null,
        confirmModal: {
            show: false,
            message: '',
            callback: null
        },
        deleteModal: {
            show: false,
            callback: null
        },
        parameters: {}

    }),
    getters: {
        getParameter: (state) => (key) => {
            return state.parameters[key] || [];
        },
        getAppLayoutSideBarExpandedWrapper(state) {
            return state.appLayout.sideBarExpandedWrapper;
        },

        // Locale
        getLocale(state) {
            return state.locale;
        },

        // Night Mode
        getNightMode(state) {
            return state.nightMode;
        },

        // Modals
        showConfirmModal(state) {
            return state.confirmModal.show;
        },
        confirmModalMessage(state) {
            return state.confirmModal.message;
        },
        confirmModalCallback(state) {
            return state.confirmModal.callback;
        },
        showDeleteModal(state) {
            return state.deleteModal.show;
        },
        deleteModalCallback(state) {
            return state.deleteModal.callback;
        },
    },
    mutations: {
        setParameter(state, { key, data }) {
            Vue.set(state.parameters, key, data);
        },

        setAppLayout(state, data) {
            state.appLayout = data;
            Base.LocalStorage.set('appLayout', state.appLayout);
        },
        setLocale(state, locale) {

            Base.LocalStorage.set('locale', locale);
            i18n.locale = locale
            state.locale = locale;
        },
        setNightMode(state, data) {
            state.nightMode = data;
            Base.LocalStorage.set('nightMode', state.nightMode);
        },
        changeAppLayoutSidebarExpandedWrapper(state) {
            state.appLayout.sideBarExpandedWrapper = !state.appLayout.sideBarExpandedWrapper;
            Base.LocalStorage.set('appLayout', state.appLayout);
        },
        changeNightMode(state) {
            state.nightMode = !state.nightMode;
            Base.LocalStorage.set('nightMode', state.nightMode);
        },
        setConfirmModal(state, obj) {
            state.confirmModal.message = obj.msg;
            state.confirmModal.show = true;
            state.confirmModal.callback = obj.callback;
        },
        closeConfirmModal(state) {
            state.confirmModal.show = false;
            state.confirmModal.callback = null;
        },
        setDeleteModal(state, obj) {
            state.deleteModal.show = true;
            state.deleteModal.callback = obj.callback;
        },
        closeDeleteModal(state) {
            state.deleteModal.show = false;
            state.deleteModal.callback = null;
        }
    },
    actions: {
        async fetchParameter({ state, commit }, { parameterCode, sort = 'name', forceRefresh = false, isPublic = false}) {
            if (state.parameters[parameterCode] && !forceRefresh) {
                return state.parameters[parameterCode];
            }
            const config = {
                params: {
                    sort: sort,
                    limit: -1,
                },
                paramsSerializer: (params) => qs.stringify(params, { encode: false }),
            };

            try {
                let res
                if (isPublic){
                    config.params.parameter_code=parameterCode
                     res = await ParameterService.getItemsPublic(config);
                }else{
                     res = await ParameterService.getItems(parameterCode, config);
                }
                commit('setParameter', { key: parameterCode, data: res.data.data});
                return res.data.data;
            } catch (err) {
                if (err.status === 406){
                    Vue.$toast.error(i18n.t('api.' + err.data.message))
                }
                if (err.status === 422) {
                    Vue.$toast.error(i18n.t('api.' + err.data.message))
                }
            }
        },

        initLocale({ commit }) {
            let locale = Base.LocalStorage.get('locale');
            if (locale && ['tr', 'en'].includes(locale)) {
                commit('setLocale', locale);
            }
            else if (process.env.VUE_APP_PROJECT_EXCEPTION==='BATUM'){
                commit('setLocale', 'ge');
            }
            else {
                commit('setLocale', 'tr');
            }
        },


        // Night Mode
        initNightMode({ commit, state }) {

            let nightMode = Base.LocalStorage.get('nightMode');
            if (nightMode) {
                commit('setNightMode', nightMode);
            }
            else {
                Base.LocalStorage.set('nightMode', state.nightMode);
            }
        },

        // App Layouts
        initAppLayouts({ commit, state }) {

            let appLayout = Base.LocalStorage.get('appLayout');
            if (appLayout) {
                commit('setAppLayout', appLayout);
            }
            else {
                Base.LocalStorage.set('appLayout', state.appLayout);
            }

        }
    }
});
